module.exports = __webpack_public_path__ + "portal-static/img/zanwu.4bb02ac5.png";